import { doGet, doPost, doPut } from 'hooks/requests';

export const useRemittanceService = () => {
    const getRemittanceFiles = (data) => {
        const params = new URLSearchParams({
            company_id: data.companyId,
            status: data.status,
        });
        return doGet(`remittance/get-files/?${params.toString()}`);
    };

    const addRemittanceFile = (data) => {
        return doPost('remittance/add-file/', data);
    };

    const matchRemittance = (data) => {
        return doPut('remittance/match/', data);
    };

    const skipRemittance = (data) => {
        return doPut('remittance/skip/', data);
    };

    return {
        skipRemittance,
        matchRemittance,
        addRemittanceFile,
        getRemittanceFiles,
    };
};
